import { writable } from 'svelte/store';
export const videoFilterState = writable({
    brightness : 100,
    contrast : 100,
    saturation : 100,
    invert : 0
});